module.exports = __webpack_public_path__ + "src/img/systemBubbles.18f40e33.png";